import { NavLink, useRouteMatch } from "react-router-dom";

//icons
import Home from "../../assets/menu-home-icon.svg";
import College from "../../assets/menu-colleges-icon.svg";
import Course from "../../assets/menu-courses-icon.svg";
import Student from "../../assets/menu-profile-icon.svg";
import Proposal from "../../assets/menu-proposal-icon.svg";
import { NavContainer } from "../../styled-components/Nav.styles";

const NavLinks = () => {
  const { url } = useRouteMatch();

  const cleaner = () => {
    // console.log("cleaner cuando se navega");
    //Establecer un modo de limpiar el state mientras se navega por la app
  };

  return (
    <NavContainer>
      <ul className="navLinks">
        <li>
          <NavLink to={`${url}`}>
            <button onClick={cleaner}>
              <div className="content text-18-blue-yonder text-18-blue-yonder--semibold ">
                <img src={Home} alt="icon redirect home" />
                <span>Home</span>
              </div>
            </button>
          </NavLink>
        </li>
        <li>
          <NavLink to={`${url}/colleges`}>
            <button onClick={cleaner}>
              <div className="content text-18-blue-yonder text-18-blue-yonder--semibold">
                <img src={College} alt="icon building college" />
                <span>Colleges</span>
              </div>
            </button>
          </NavLink>
        </li>
        <li>
          <NavLink to={`${url}/courses`}>
            <button onClick={cleaner}>
              <div className="content text-18-blue-yonder text-18-blue-yonder--semibold">
                <img src={Course} alt="icon book course" />
                <span>Courses</span>
              </div>
            </button>
          </NavLink>
        </li>
        <li>
          <NavLink to={`${url}/students`}>
            <button onClick={cleaner}>
              <div className="content text-18-blue-yonder text-18-blue-yonder--semibold">
                <img src={Student} alt="icon student figure" />
                <span>Students</span>
              </div>
            </button>
          </NavLink>
        </li>
        <li>
          <NavLink to={`${url}/proposals`}>
            <button onClick={cleaner}>
              <div className="content text-18-blue-yonder text-18-blue-yonder--semibold">
                <img src={Proposal} alt="icon proposal" />
                <span>Proposals</span>
              </div>
            </button>
          </NavLink>
        </li>
      </ul>
    </NavContainer>
  );
};

export default NavLinks;
